
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/virtual",
      function () {
        return require("private-next-pages/virtual/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/virtual"])
      });
    }
  